import { render, staticRenderFns } from "./TipRule.vue?vue&type=template&id=27349823&scoped=true&"
import script from "./TipRule.vue?vue&type=script&lang=js&"
export * from "./TipRule.vue?vue&type=script&lang=js&"
import style0 from "./TipRule.vue?vue&type=style&index=0&id=27349823&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27349823",
  null
  
)

export default component.exports